module.exports = __webpack_public_path__ + "static/media/washington-dc-73.f4379860.jpg";